import React from 'react';

import MainTemplate from 'pages/templates/MainTemplate';

const FrameRTB = () => {
  return (
    <MainTemplate>
      <h2>프레임 RTB</h2>
    </MainTemplate>
  );
};

export default FrameRTB;
